// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"e5002aff","936":"bc19aa9e"}[chunkId] + ".chunk.js";
};